import { useRef, useState, useCallback } from "react";
import { MoveHorizontal } from "lucide-react";

export const CompareSlider = ({ item, testid, alt }) => {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);

  const setFromClientX = useCallback((clientX) => {
    const rect = ref.current.getBoundingClientRect();
    const pct = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, pct)));
  }, []);

  const onMove = (e) => {
    if (!dragging.current) return;
    const x = e.touches ? e.touches[0].clientX : e.clientX;
    setFromClientX(x);
  };

  return (
    <div
      ref={ref}
      data-testid={testid}
      className="group relative aspect-[4/3] w-full overflow-hidden rounded-3xl border border-border bg-navy-deep select-none cursor-ew-resize"
      onMouseDown={(e) => {
        dragging.current = true;
        setFromClientX(e.clientX);
      }}
      onMouseMove={onMove}
      onMouseUp={() => (dragging.current = false)}
      onMouseLeave={() => (dragging.current = false)}
      onTouchStart={(e) => {
        dragging.current = true;
        setFromClientX(e.touches[0].clientX);
      }}
      onTouchMove={onMove}
      onTouchEnd={() => (dragging.current = false)}
    >
      <img
        src={item.after}
        alt={alt ? `${alt} — na` : `${item.title} - na`}
        className="absolute inset-0 h-full w-full object-cover"
        draggable="false"
      />
      <div
        className="absolute inset-0 h-full w-full overflow-hidden"
        style={{ width: `${pos}%` }}
      >
        <img
          src={item.before}
          alt={alt ? `${alt} — voor` : `${item.title} - voor`}
          className="absolute inset-0 h-full max-w-none object-cover"
          style={{ width: ref.current?.offsetWidth || "100%" }}
          draggable="false"
        />
        <span className="absolute left-4 top-4 rounded-full bg-navy-deep/80 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-white backdrop-blur">
          Voor
        </span>
      </div>
      <span className="absolute right-4 top-4 rounded-full bg-teal px-3 py-1 text-xs font-semibold uppercase tracking-wide text-white">
        Na
      </span>

      <div
        className="absolute inset-y-0 z-10 w-0.5 bg-white"
        style={{ left: `${pos}%` }}
      >
        <span className="absolute top-1/2 left-1/2 grid h-11 w-11 -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full bg-white text-navy shadow-lg">
          <MoveHorizontal className="h-5 w-5" />
        </span>
      </div>

      {item.title && (
        <div className="absolute bottom-4 left-4 z-10">
          <p className="font-display text-lg font-bold text-white">
            {item.title}
          </p>
          {item.meta && <p className="text-xs text-white/70">{item.meta}</p>}
        </div>
      )}
    </div>
  );
};

export default CompareSlider;
